var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import Button from "./button";
import { Icon } from "./icon";
import * as ReactDOM from "react-dom";
import { bind } from "decko";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
import { RevoTooltip } from "./revo-tooltip";
const dropdownButtonWrapperClass = css({
    display: "inline-block",
    position: "relative",
});
const dropdownButtonListClass = css({
    margin: 0,
    position: "absolute",
    zIndex: 10000,
    backgroundColor: getThemeColorVar("white", undefined),
    boxShadow: "0px 6px 32px 0px rgba(0, 0, 0, 0.21)",
    borderRadius: "5px",
    marginTop: "4px",
    padding: "12px 0",
    hr: {
        marginTop: "4px",
        marginBottom: "4px",
    },
});
const alignmentClasses = {
    left: css({
        left: 0,
    }),
    right: css({
        right: 0,
    }),
};
const dropdownButtonClass = css({
    paddingRight: 0,
    "> button, > a": {
        paddingRight: 0,
    },
});
const listItemClass = css({
    listStyle: "none",
    ":hover": {
        backgroundColor: getThemeColorVar("background", "lighter"),
    },
    padding: 4,
    "button, a": {
        padding: "0 24px",
        border: "0px",
        display: "block",
        textAlign: "left",
    },
    "~ li": {
        paddingTop: "8px",
    },
});
export class DropdownButton extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
    }
    componentDidUpdate() {
        if (this.props.autoClose)
            this.setState({
                open: false,
            });
    }
    componentWillMount() {
        document.addEventListener("click", this.handleOutsideClick.bind(this));
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.handleOutsideClick.bind(this));
    }
    renderItem(item, index) {
        if (item === "divider") {
            return React.createElement("hr", { key: index });
        }
        else {
            const { title } = item, props = __rest(item, ["title"]);
            const enriched = Object.assign(Object.assign({}, props), { type: "secondary" });
            return (React.createElement("li", { key: index, className: cx(listItemClass) },
                React.createElement(Button, Object.assign({}, enriched, { onClick: (e) => {
                        enriched.onClick && enriched.onClick(e);
                        this.setState({ open: false });
                    } }), title)));
        }
    }
    handleOutsideClick(event) {
        try {
            const domNode = ReactDOM.findDOMNode(this);
            if (domNode &&
                domNode.contains &&
                !domNode.contains(event.target)) {
                this.setState({
                    open: false,
                });
            }
        }
        catch (e) {
        }
    }
    renderButton() {
        return (React.createElement("div", { className: cx(dropdownButtonClass) },
            React.createElement(Button, Object.assign({}, this.props, { onClick: () => this.setState({ open: !this.state.open }) }),
                this.props.children,
                React.createElement(Icon, { name: this.state.open ? "arrow_drop_up" : "arrow_drop_down" }))));
    }
    render() {
        const _a = this.props, { actions } = _a, props = __rest(_a, ["actions"]);
        const listClasses = [dropdownButtonListClass];
        this.props.alignment &&
            listClasses.push(alignmentClasses[this.props.alignment]);
        return (React.createElement("div", { className: cx(dropdownButtonWrapperClass) },
            props.tooltip && (React.createElement(RevoTooltip, { text: props.tooltip, position: "down" }, this.renderButton())),
            !props.tooltip && this.renderButton(),
            this.state.open && (React.createElement("ul", { className: cx(listClasses) }, actions.map(this.renderItem)))));
    }
}
DropdownButton.defaultProps = {
    alignment: "right",
};
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Number]),
    __metadata("design:returntype", void 0)
], DropdownButton.prototype, "renderItem", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DropdownButton.prototype, "handleOutsideClick", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DropdownButton.prototype, "renderButton", null);
export default DropdownButton;
//# sourceMappingURL=dropdown-button.js.map